<template>
  <div class="count-flop" :key="compKey">
    <template v-for="(item, index) in value">
      <div class="count-flop-box" :key="'div_' + index">
        <div class="count-flop-content" :class="['rolling_' + item]">
          <div v-for="(item2, index2) in numberList" :key="index2" class="count-flop-num">
            {{ item2 }}
          </div>
        </div>
        <!--      <div v-else class="count-flop-content">.</div>-->
      </div>
      <!--      <span :key="'span_'+index">,</span>-->
      <span
        class="count-flop-span"
        v-if="(value.length - 1 - index) % 3 === 0 && value.length - 1 - index !== 0"
        :key="'span_' + index"
        >,</span
      >
    </template>

    <div v-if="suffix" class="count-flop-unit">{{ suffix }}</div>
  </div>
</template>
<script>
import animate from 'animate.css'
export default {
  data() {
    return {
      value: [],
      numberList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      compKey: 0
    }
  },
  props: ['val', 'suffix'],
  watch: {
    val() {
      // this.value = this.val.toString().split("");
      this.value = this.todayNumFormat(this.val).split('')
      this.compKey += 1
    }
  },
  created() {
    // this.value = this.val.toString().split("");
    this.value = this.todayNumFormat(this.val).split('')
  },
  methods: {
    todayNumFormat(val) {
      let strNumber = val.toString()
      let len = 0
      if (strNumber.length < 4) {
        len = 4 - strNumber.length
      }
      for (let i = 0; i < len; i++) {
        strNumber = '0' + strNumber.slice(0)
      }
      return strNumber
    }
  }
}
</script>
<style scoped>
.count-flop {
  display: inline-block;
  font-size: 0;
  /* 可更改 */
  height: 48px;
  font-size: 48px;
  font-family: Barlow-SemiBold, Barlow;
  font-weight: 600;
  color: #ffffff;
  line-height: 48px;
  /*color: #4898f1;*/
}

.count-flop > div {
  position: relative;
  display: inline-block;
  overflow: hidden;
  height: 100%;
  margin-right: 0px;
}

.count-flop-box {
  /* 可更改 */
  /*margin-right: 5px;*/
  /*width: 36px;*/
  /*border: 1px solid rgba(72, 152, 241, 0.3);*/
  /*line-height: 48px;*/
  /*border-radius: 6px;*/

  display: inline-block;
  margin-bottom: 8px;
  width: 26px;
  height: 48px;
  font-size: 48px;
  font-family: Barlow-SemiBold, Barlow;
  font-weight: 600;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
  /*background-image: url('./num_bg.png');*/
  /*background-repeat: no-repeat;*/
  /*background-size: 100% 100%;*/
  /*opacity: 1;*/
}

.count-flop-point {
  /* 可更改 */
  margin-right: 5px;
  width: 10px;
}

.count-flop-content {
  font-family: Barlow-SemiBold, Barlow;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  animation-fill-mode: forwards !important;
}
.count-flop-span {
  position: relative;
  top: -20px;
  font-size: 40px;
}
.rolling_0 {
  animation: rolling_0 2.1s ease;
}

@keyframes rolling_0 {
  from {
    transform: translateY(-90%);
  }
  to {
    transform: translateY(0);
  }
}

.rolling_1 {
  animation: rolling_1 3s ease;
}

@keyframes rolling_1 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10%);
  }
}

.rolling_2 {
  animation: rolling_2 2.1s ease;
}

@keyframes rolling_2 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20%);
  }
}

.rolling_3 {
  animation: rolling_3 3s ease;
}

@keyframes rolling_3 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-30%);
  }
}

.rolling_4 {
  animation: rolling_4 2.1s ease;
}

@keyframes rolling_4 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-40%);
  }
}

.rolling_5 {
  animation: rolling_5 3s ease;
}

@keyframes rolling_5 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50%);
  }
}

.rolling_6 {
  animation: rolling_6 2.1s ease;
}

@keyframes rolling_6 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-60%);
  }
}

.rolling_7 {
  animation: rolling_7 3.1s ease;
}

@keyframes rolling_7 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-70%);
  }
}

.rolling_8 {
  animation: rolling_8 2.1s ease;
}

@keyframes rolling_8 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-80%);
  }
}

.rolling_9 {
  animation: rolling_9 3.6s ease;
}

@keyframes rolling_9 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-90%);
  }
}
</style>
